import { axiosPublic } from "../../api/axios";

const checkIPBlock = async () => {
  try {
    const response = await axiosPublic.get("/ip-blocks/check-ip");
    return response.data;
  } catch (error) {
    return { isBlocked: false, blockInfo: null };
  }
};

const ipService = {
  checkIPBlock,
};

export default ipService;
